module.exports = __webpack_public_path__ + "bg-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/bg-2.jpg
// module id = 262
// module chunks = 0